import { io, Socket } from "socket.io-client";
import { BACKEND_URL } from "./api";

let presenceSocket: Socket | null = null;
let chatSocket: Socket | null = null;

export const getPresenceSocket = () => {
  if (!presenceSocket) {
    presenceSocket = io(`${BACKEND_URL}/presence`, {
      transports: ["websocket"],
      withCredentials: true,
    });

    presenceSocket.on("connect", () => {
      console.log("Presence socket connected", presenceSocket?.id);
    });

    presenceSocket.on("disconnect", (reason) => {
      console.log("Presence socket disconnected:", reason);
    });
  }

  return presenceSocket;
};

export const getChatSocket = () => {
  if (!chatSocket) {
    chatSocket = io(`${BACKEND_URL}/chat`, {
      transports: ["websocket"],
      withCredentials: true,
    });

    chatSocket.on("connect", () => {
      console.log("Chat socket connected", chatSocket?.id);
    });

    chatSocket.on("disconnect", (reason) => {
      console.log("Chat socket disconnected:", reason);
    });
  }
  return chatSocket;
};
